import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import {
  GET_COMPANIES,
  GET_COMPANY_TYPES,
  GET_DEACTIVATED_PROJECT,
  get_headers,

  verify_super_user_status
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';

import axios from "axios";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';


export default {
  name: 'CompanyManagement',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    navbar,
    GlobalTable,
    AICampusFooter
  },

  data: () => ({
    headers: get_headers(),
    company_types: [],
    company_list: [],
    table_headers: [],
    table_safe_company_list: [],
    company_name: '',
    selected_company_type: '',
    company_description: '',
    project_id: '',
    company_count: 0,
    is_loading: false,
    role: sessionStorage.getItem('user_role') || null,
    users: [],
    users_list: [],
    user_table_headers: [],
    assigned_users: [],
    deactivated_projects: [],
    update_company_name: '',
    update_company_description: '',
    update_selected_company_type: [],
    hostname: '',
    hero_title: '',
    hero_description: '',
    is_super_user: false,

    // ✅ NEW: track active configured programme
    active_config_project: sessionStorage.getItem('project_id') || null,
  }),

  mounted() {
    this.load_data();
    this.get_deactivated_projects();
    this.hostname = window.location.hostname || '';
  },

  methods: {

    /* ===============================
       TOGGLE CONFIGURATION LOGIC
    ================================ */

    isSelectedProject(project_id) {
      return String(this.active_config_project) === String(project_id);
    },

    toggle_config_project(row) {
      const project_id = row.id;
      const company_name = row.Client;

      // If already selected, do nothing
      if (this.isSelectedProject(project_id)) return;

      this.active_config_project = project_id;

      // Save in session
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('company_name', company_name);

    },

    /* ===============================
       EXISTING METHODS (UNCHANGED)
    ================================ */

    async load_data() {
      this.is_loading = true;
      try {
        await Promise.all([
          this.is_super_user = await verify_super_user_status(),
          this.get_project_types(),
          this.get_companies(),
        ]);
      } catch (error) {
        this.show_error('Error loading data: ' + error);
      } finally {
        this.is_loading = false;
      }
    },

    get_project_types() {
      return axios.get(GET_COMPANY_TYPES, {
        headers: this.headers
      })
        .then(response => {
          const parsed = JSON.parse(response.data);
          this.company_types = parsed.data || [];
        })
        .catch(error => {
          this.show_error('Error getting company types: ' + error);
        });
    },

    get_companies() {
      return axios.get(GET_COMPANIES, {
        headers: this.headers
      })
        .then(response => {
          const parsed = JSON.parse(response.data);
          this.company_list = parsed.data || [];
          this.company_count = this.company_list.length;
          this.prep_tables();
        })
        .catch(error => {
          this.show_error('Error getting companies: ' + error);
        });
    },

    prep_tables() {
      if (this.company_list.length > 0) {
        this.table_safe_company_list = this.company_list.map(company => ({
          id: company.id,
          Programme: company.name,
          Description: company.project_description,
          Type: company.project_type.name,
          "Date Created": this.format_date(company.date_created),
          "Assigned Administrator": company.creator.full_name,
        }));

        this.table_headers = Object.keys(this.table_safe_company_list[0]);
      } else {
        this.table_headers = ["Programme", "Description", "Type", "Date Created", "Assigned Administrator"];
      }
    },


    get_deactivated_projects() {
      axios.get(GET_DEACTIVATED_PROJECT, { headers: this.headers })
        .then(response => {
          const parsed = JSON.parse(response.data);
          this.deactivated_projects = parsed.data || [];
        })
        .catch(error => {
          this.show_error("Error fetching deactivated clients: " + error);
        });
    }

  }
};